<template>
  <div>
    <qrcode-vue :value="url" :size="size" level="H" />
  </div>
</template>

<script>
  import QrcodeVue from 'qrcode.vue'
  export default {
    name: "QrcodeVueTemplate",
    props: {
        size: String ,
        url: String
    },
    components: {
      QrcodeVue,
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/QrcodeVueTemplate.vue